import { useEffect, useState } from 'react';
import { Cake, Loader2 } from 'lucide-react';
import { baseApi, BaseApiError } from '../../../api/baseClient';

// «No sumar multiplicadores» (24-oct-2026, Hogar China City: «si cae el mismo día de su cumple y el día de puntos,
// que no se sume el x2 y el x1.5: se escoge el más grande»). Interruptor por negocio (tenant_settings.loyalty_flags.
// multipliers_no_stack), apagado por defecto = se multiplican como siempre. Se guarda AL INSTANTE. Motor: lib/loyalty.js.
export default function MultipliersNoStackToggle() {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    baseApi.get<{ multipliersNoStack?: boolean }>('/loyalty/settings')
      .then((d) => { if (vivo) setEnabled(!!d.multipliersNoStack); })
      .catch(() => { if (vivo) setEnabled(false); });
    return () => { vivo = false; };
  }, []);

  const toggle = async () => {
    if (enabled === null || saving) return;
    const next = !enabled;
    setSaving(true); setError(null);
    try {
      const r = await baseApi.put<{ multipliersNoStack: boolean }>('/loyalty/multipliers-no-stack', { enabled: next });
      setEnabled(!!r.multipliersNoStack);
    } catch (e) {
      setError(e instanceof BaseApiError ? e.message : 'No se pudo guardar. Intenta de nuevo.');
    } finally { setSaving(false); }
  };

  return (
    <div className="pt-3 border-t border-line">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-2">
          <Cake className="h-5 w-5 text-pink-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-content">Si cae en su cumpleaños, no sumar: gana el mayor</p>
            <p className="text-xs text-content-3 mt-0.5">
              Apagado, si el cumpleaños del cliente cae en un día con premio extra se multiplican los dos (x2 × x1.5 = x3).
              Encendido, se aplica solo el mayor (x2).
            </p>
            {error && <p className="text-xs text-red-600 dark:text-red-400 mt-1">{error}</p>}
          </div>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={!!enabled}
          aria-label="Si cae en su cumpleaños, no sumar multiplicadores"
          onClick={toggle}
          disabled={enabled === null || saving}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-60 ${enabled ? 'bg-green-600' : 'bg-gray-300 dark:bg-gray-600'}`}
        >
          {saving || enabled === null
            ? <Loader2 className="w-4 h-4 animate-spin text-white mx-auto" />
            : <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${enabled ? 'translate-x-5' : 'translate-x-0.5'}`} />}
        </button>
      </div>
    </div>
  );
}
